import React, { Component } from 'react'
import { Button } from '@driftt/tide-core-legacy'

import style from './style.styl'

class DisconnectLink extends Component {
  render() {
    const { serviceName, handleDisconnect } = this.props
    return (
      <Button
        className={`flex ${style.IntegrationControl} ${style.IntegrationLink} ${style.DisconnectLink} 'tertiary`}
        onClick={handleDisconnect}>
        Disconnect from {serviceName}
      </Button>
    )
  }
}

export default DisconnectLink



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/DisconnectLink.js